import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const getUserProfile = async (userId) => {
  const userRef = doc(db, 'users', userId);
  const userSnap = await getDoc(userRef);
  return userSnap.exists() ? userSnap.data() : null;
};

export const createUserProfile = async (user) => {
  const userRef = doc(db, 'users', user.uid);
  
  await setDoc(userRef, {
    uid: user.uid,
    email: user.email,
    displayName: '',
    notificationEmail: '',
    profileCompleted: false,
    termsAccepted: false,
    termsAcceptedAt: null,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  });
};

export const updateUserProfile = async (userId, profileData) => {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, {
    ...profileData,
    profileCompleted: true,
    updatedAt: new Date().toISOString()
  });
};

export const acceptTerms = async (userId) => {
  const userRef = doc(db, 'users', userId);
  await updateDoc(userRef, {
    termsAccepted: true,
    termsAcceptedAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  });
}; 